<script>
  import Counter2 from "../../../Publish/BulkUpload/Shared/counter2.svelte"
  export let count = {
    view: 0,
    verify: 0,
    download: 0,
    publish: 0,
  }
</script>

<div class="grid w-full grid-cols-1 items-center gap-3 mobile:grid-cols-2">
  <Counter2 span="col-span-2" count={count.publish || 0} icon={"fa-file"} titleText={"ISSUED"} color={"#ff6a00"} gradient={"#f8a500, #ff6a00"} />
  <Counter2 span="col-span-2" count={count.view || 0} icon={"fa-eye"} titleText={"VIEWED"} color={"#00B2FF"} gradient={"#A3E3FF, #00B2FF"} />
  <Counter2 span="col-span-2" count={count.verify || 0} icon={"fa-circle-check"} titleText={"VERIFIED"} color={"#00D515"} gradient={"#58FE69, #00D515"} />
  <Counter2 span="col-span-2" count={count.download || 0} icon={"fa-download"} titleText={"DOWNLOADED"} color={"#b589d6"} gradient={"#9969c7,#6a359c"} />
</div>
